export const createClassicRewardsAvailabilityMessage = (isLoading, depositPay) => {
  if (!isLoading && depositPay) {
    return 'not available with Deposit Pay';
  }

  return null;
};
